import {SET_PLACES, SET_AGENDA_PLACES, LOGIN_USER,INITIAL_SET, /*SIGNUP_USER,*/ SIGNOUT_USER, SET_CALENDAR_LIST, SET_NEW_USER_AGENDA, SET_NEW_INV_AGENDA, SET_CALENDAR_INV_LIST, SET_CALENDAR_PUBLIC, SET_USERS_SOCKET, SET_USERS_MSG_SOCKET, SET_NEW_USER_INV_AGENDA, SET_CALENDAR_LOADING, SET_CALENDAR_NAME, SET_SHOP_LIST, SET_CALENDAR_LIST_PAGE, SET_CALENDAR_COUNT_ITEMS, SET_PLACE_IN_LIST, SET_UNREGISTER_USER_AGENDA, SET_BLOGS_LIST_QUERY, SET_PLACES_ADMIN_LIST_QUERY} from '../const'
import FixItems, { reversetravel, selectStartHour, /*travelMode*/ } from '../../utils/fixItems'
import api from '../../utils/axiosApi'
import Cookies from 'universal-cookie'
import jwtDecode from 'jwt-decode';
import moment from 'moment';
import { getRandomColor } from '../../utils/getRandomColor';
import axios from 'axios';
import LogRocket from 'logrocket';
import _/*, { findIndex }*/ from 'lodash';
import SortDate from '../../utils/sortDate';
import { startTimeActivities, startTimeCalendar } from '../../utils/const';
const cookies = new Cookies()

//modifican el calendario
export const setPlaces = value => ({type: SET_PLACES, value});
export const setAgendaPlaces = value => ({type: SET_AGENDA_PLACES, value});
export const setinitialvalues = value => ({type: INITIAL_SET, value});
export const changeName = value => ({type: SET_CALENDAR_NAME, value});
export const saveUsersInv = value => ({type: SET_NEW_USER_INV_AGENDA, value});
export const setLoadingCalendar = value => ({type: SET_CALENDAR_LOADING, value});
//modifican la lista de los calendarios
const setcalendarlist = value => ({type: SET_CALENDAR_LIST, value});
const setcalendarlistPage = value => ({type: SET_CALENDAR_LIST_PAGE, value});
const setcalendarlistCount = value => ({type: SET_CALENDAR_COUNT_ITEMS, value});
const setUserShopCarList = value => ({type: SET_SHOP_LIST, value});
export const setPlacesList = value => ({type: SET_PLACE_IN_LIST, value});
export const setBlogsList = value => ({type: SET_BLOGS_LIST_QUERY, value});
export const setPlacesAdminList = value => ({type: SET_PLACES_ADMIN_LIST_QUERY, value});
export const setUnregisterUsers = value => ({type: SET_UNREGISTER_USER_AGENDA, value});
//const setPlacesList = value => ({type: SET_PLACE_IN_LIST, value});
//funciones para el chat que no esta operativo por rediseño
export const setUsersSocket = value => ({type: SET_USERS_SOCKET, value});
export const setUsersMsgsSocket = value => ({type: SET_USERS_MSG_SOCKET, value});
//const setPlace = value => ({type: SET_PLACE, value});

//placesAdmin-----------------------------------------------------------------------------------------------------------------

//la shopcar list es la lista de los lugares que el usuario quiere in en una ciudad
export const setPlacesAdmin = (payload={}) => {
    return async (dispatch, getState) => {

        const { query='',hidden ='', incomplete='',page=0,city=''} = payload
        debugger
        //const state = getState()
        //const localToken = window.sessionStorage.getItem('jwtuser')|| localStorage.getItem('jwtuser')
       // const auth = state.user.token || localToken //cookies.get('jwtuser')
        var newListShop=[]
        try {
            const data = {
                page:page,
                places :[],
                Nitems : 0,
                query : query,
                city
            }
            dispatch(setPlacesAdminList(data))
        } catch (error) {
            console.log(error)
        }
        try {
            
            const respcountry = await api.get(`/adminsplaces/getfromcountry?country=${query}&&onlyHidden=${hidden}&&onlyIncomplete=${incomplete}&&PagNumber=${page}&&city=${city}`)
            const data = {
                page: page,
                places : respcountry.data.data,
                Nitems : respcountry.data.items,
                query : query,
                hidden, incomplete,city
            }
            dispatch(setPlacesAdminList(data))
            
            
        } catch (error) {
            console.log(error)
            return error
        }
        return newListShop
    }
}
//cargar nuevos blogs
export const loadNextPlacesAdmins = (payload) => {
    return async (dispatch, getState) => {
        //en esta se obtiene la lista de la ciudad determinada
        try {
            //
            const state = getState()
            var query = state.adminPlaces.query
            var page = ++state.adminPlaces.page
            var hidden = state.adminPlaces.hidden
            var city = state.adminPlaces.city
            var incomplete = state.adminPlaces.incomplete
            const respcountry = await api.get(`/adminsplaces/getfromcountry?country=${query}&&onlyHidden=${hidden}&&onlyIncomplete=${incomplete}&&PagNumber=${page}&&city=${city}`)
            
            const data = {
                page: page,
                places : respcountry.data.data,
                Nitems : respcountry.data.items,
                query : query,
                hidden, incomplete,city
            }
            dispatch(setPlacesAdminList(data))
            return page
            
        } catch (error) {
            //console.log(error)
            return error
        }
    }
}
export const loadPrevPlacesAdmins = (payload) => {
    return async (dispatch, getState) => {
        //en esta se obtiene la lista de la ciudad determinada
        try {
            //
            const state = getState()
            var query = state.adminPlaces.query
            var page = --state.adminPlaces.page
            var hidden = state.adminPlaces.hidden
            var incomplete = state.adminPlaces.incomplete
            var city = state.adminPlaces.city
            const respcountry = await api.get(`/adminsplaces/getfromcountry?country=${query}&&onlyHidden=${hidden}&&onlyIncomplete=${incomplete}&&PagNumber=${page}&&city=${city}`)
            
            const data = {
                page: page,
                places : respcountry.data.data,
                Nitems : respcountry.data.items,
                query : query,
                hidden, incomplete,city
            }
            dispatch(setPlacesAdminList(data))
            return page
        } catch (error) {
            //console.log(error)
            return error
        }
    }
}
//elimina el blog y lo retira de la lista
export const toggleHidePlacesAdmininList = (payload) => {
    return async (dispatch, getState) => {
        try {
            debugger
            const state = getState()
            //const code = state.calendar.code
            //const auth = state.user.token  //cookies.get('jwtuser')
            var List = [...state.adminPlaces.places]
            const blogId = List.findIndex((u) => (u._id === payload))
            if(!(blogId>=0)){return}
           
            const respbd = await api.get(`/adminsplaces/toggleHide/${payload}`)
            if(!respbd.data.error && blogId>=0) {

                var query = state.adminPlaces.query
                var page = state.adminPlaces.page
                var hidden = state.adminPlaces.hidden
                var incomplete = state.adminPlaces.incomplete
                var city = state.adminPlaces.city
                const respcountry = await api.get(`/adminsplaces/getfromcountry?country=${query}&&onlyHidden=${hidden}&&onlyIncomplete=${incomplete}&&PagNumber=${page}&&city=${city}`)
                const data = {
                    page: page,
                    places : respcountry.data.data,
                    Nitems : respcountry.data.items,
                    query : query,
                    hidden, incomplete,city
                }
                /*const calendarioscopy = [...List]
                const ideliminar = calendarioscopy.findIndex((element) => {
                    return element._id === payload
                })
                calendarioscopy[ideliminar].hide = !calendarioscopy[ideliminar].hide
                const data = {
                    page: state.adminPlaces.page,
                    places : calendarioscopy,
                    Nitems : (state.adminPlaces.Nitems),
                    query : state.adminPlaces.query,
                    hidden : state.adminPlaces.hidden,
                    incomplete : state.adminPlaces.incomplete
                }*/
                dispatch(setPlacesAdminList(data))
                return true
            } 
        } catch (error) {
            //console.log(error)
            return error
        }
    }
}
//elimina el blog y lo retira de la lista
export const toggleIncompletePlacesAdmininList = (payload) => {
    return async (dispatch, getState) => {
        try {
            debugger
            const state = getState()
            //const code = state.calendar.code
            //const auth = state.user.token  //cookies.get('jwtuser')
            var List = [...state.adminPlaces.places]
            const blogId = List.findIndex((u) => (u._id === payload))
            if(!(blogId>=0)){return}
           
            const respbd = await api.get(`/adminsplaces/toggleincomplete/${payload}`)
            if(!respbd.data.error && blogId>=0) {
                /*const calendarioscopy = [...List]
                const ideliminar = calendarioscopy.findIndex((element) => {
                    return element._id === payload
                })
                calendarioscopy[ideliminar].hide = !calendarioscopy[ideliminar].hide
                const data = {
                    page: state.adminPlaces.page,
                    places : calendarioscopy,
                    Nitems : (state.adminPlaces.Nitems),
                    query : state.adminPlaces.query,
                    hidden : state.adminPlaces.hidden,
                    incomplete : state.adminPlaces.incomplete
                }*/
                var query = state.adminPlaces.query
                var page = state.adminPlaces.page
                var hidden = state.adminPlaces.hidden
                var incomplete = state.adminPlaces.incomplete
                var city = state.adminPlaces.city
                const respcountry = await api.get(`/adminsplaces/getfromcountry?country=${query}&&onlyHidden=${hidden}&&onlyIncomplete=${incomplete}&&PagNumber=${page}&&city=${city}`)
                const data = {
                    page: page,
                    places : respcountry.data.data,
                    Nitems : respcountry.data.items,
                    query : query,
                    hidden, incomplete,city
                }
                dispatch(setPlacesAdminList(data))
                return true
            } 
        } catch (error) {
            //console.log(error)
            return error
        }
    }
}
//cambia el estado incompleto a todos los elementos en la pagina actual
export const toggleAllIncompletePlacesAdmininList = (payload) => {
    return async (dispatch, getState) => {
        try {
            debugger
            const state = getState()
            var List = state.adminPlaces.places
            for(const activitie of List) {

                /*const respbd = */await api.get(`/adminsplaces/toggleincomplete/${activitie._id}`)
            }
            var query = state.adminPlaces.query
            var page = state.adminPlaces.page
            var hidden = state.adminPlaces.hidden
            var incomplete = state.adminPlaces.incomplete
            var city = state.adminPlaces.city
            const respcountry = await api.get(`/adminsplaces/getfromcountry?country=${query}&&onlyHidden=${hidden}&&onlyIncomplete=${incomplete}&&PagNumber=${page}&&city=${city}`)
            const data = {
                page: page,
                places : respcountry.data.data,
                Nitems : respcountry.data.items,
                query : query,
                hidden, incomplete,city
            }
            dispatch(setPlacesAdminList(data))
        } catch (error) {
            //console.log(error)
            return error
        }
    }
}
//elimina el blog y lo retira de la lista
export const deletePlacesAdmininList = (payload) => {
    return async (dispatch, getState) => {
        try {
            debugger
            const state = getState()
            //const code = state.calendar.code
            const auth = state.user.token  //cookies.get('jwtuser')
            var List = [...state.adminPlaces.places]
            const blogId = List.findIndex((u) => (u._id === payload))
            if(!(blogId>=0)){return}
            var respbd = await api.delete(`/adminsplaces/delete/${payload}`,{
                headers : {
                    Authorization: `Bearer ${auth}`
                }
            })
            
            if(!respbd.data.error && blogId>=0) {
                const calendarioscopy = [...List]
                const ideliminar = calendarioscopy.findIndex((element) => {
                    return element._id === payload
                })
                calendarioscopy.splice(ideliminar, 1)
                const data = {
                    page: state.adminPlaces.page,
                    places : calendarioscopy,
                    Nitems : (state.adminPlaces.Nitems),
                    query : state.adminPlaces.query,
                    hidden : state.adminPlaces.hidden,
                    incomplete : state.adminPlaces.incomplete
                }
                dispatch(setPlacesAdminList(data))
                return true
            } 
        } catch (error) {
            //console.log(error)
            return error
        }
    }
}
//reemplaza un articulo por otro ya editado
export const replacePlacesAdmininList = (payload) => {
    return async (dispatch, getState) => {
        try {
            debugger
            const state = getState()
            //const code = state.calendar.code
            //const auth = state.user.token  //cookies.get('jwtuser')
            var List = [...state.adminPlaces.places]
            const blogId = List.findIndex((u) => (u._id === payload._id))
            if(!(blogId>=0)){return}
            List[blogId] = payload
            const data = {
                page: state.adminPlaces.page,
                places : List,
                Nitems : (state.adminPlaces.Nitems),
                query : state.adminPlaces.query,
                hidden : state.adminPlaces.hidden,
                incomplete : state.adminPlaces.incomplete
            }
            dispatch(setPlacesAdminList(data))
        } catch (error) {
            //console.log(error)
            return error
        }
    }
}

/*-----------------------------------------------------------------------login----------------------*/


export const setLogin = value => ({type: LOGIN_USER, value});
//const setSignup = value => ({type: SIGNUP_USER, value});
const signout = value => ({type: SIGNOUT_USER, value});

export const setLoginUser = (payload) => {
    return async (dispatch, getState) => {
        
        try {
            //se loguea el usuario 
            const resp = await api.post(`/user/login`, payload, {withCredentials: true})
            const {user}=jwtDecode(resp.data.data.token)
            LogRocket.identify(`${user._id}`, {
                name: `${user.name} ${user.lastNname}`,
                email: `${user.email}`,
                
                // Add your own custom user variables here, ie:
            });
            //se guarda el token en caso de presionar que se desea guardar
            if(payload.remenber) {
                //cookies.set('jwtuser', resp.data.data.token )
                localStorage.setItem('jwtuser',resp.data.data.token)
            } else {
                window.sessionStorage.setItem('jwtuser', resp.data.data.token);
                //cookies.set('jwtuser', resp.data.data.token,{maxAge: 1000 * 60 *60 *12} )
            }
            
            api.defaults.headers.common['Authorization'] = `Bearer ${resp.data.data.token}`
            dispatch(setLogin(resp.data.data.token))
        } catch (error) {
            dispatch(setLogin(''))
            //console.log(error)
            return error?.response?.data?.message
        }
    }
}
//desloguea el usuario y elimina el token
export const setSignout = (payload) => {
    return async (dispatch, getState) => {
        try {
            await api.get(`/user/logout`, {withCredentials: true})

            const token = window.sessionStorage.getItem('jwtuser')|| localStorage.getItem('jwtuser')
            if(token && token !== '') {
                localStorage.removeItem('jwtuser')
                window.sessionStorage.removeItem('jwtuser')
            }
            cookies.set('jwtuser', '',{maxAge: 12})
            delete api.defaults.headers.common['Authorization']
            
            var newListShop=[]
            const data = {
                list: newListShop
            }
            dispatch(setUserShopCarList(data))
            dispatch(setcalendarlist([]))
            dispatch(setcalendarlistPage(0))
            dispatch(setcalendarlistCount(0))
            dispatch(signout())
        } catch (error) {
            dispatch(setLogin(''))
            //console.log(error)
            return false
        }
    }
}
//crea un nuevo uduario 
export const setSignupUser = ({payload,len}) => {
    return async (dispatch, getState) => {
        try {
            const resp = await api.post(`/user/signup?len=${len}`, payload, {withCredentials: true})
            
            localStorage.setItem('jwtuser',resp.data.token)
            const {user}=jwtDecode(resp.data.token)
            LogRocket.identify(`${user._id}`, {
                name: `${user.name}`,
                email: `${user.email}`,
                // Add your own custom user variables here, ie:
            });
            dispatch(setLogin(resp.data.token))
        } catch (error) {
            dispatch(setLogin(''))
            const {keyPattern} = error.response.data.message
            //console.log(error)
            return keyPattern
        }
    }
}/*
export const setSignupCustomer = (payload) => {
    return async (dispatch, getState) => {
        try {
            const resp = await api.post(`/user/signupcustomer`, payload)
            const token = localStorage.getItem('jwtuser') //cookies.get('jwtuser')
            if(!token) {
                cookies.set('jwtuser', resp.data.token, {maxAge: 1000 * 60 *60 *24} )
            }
            dispatch(setLogin(resp.data.token))
        } catch (error) {
            dispatch(setLogin(''))
            //console.log(error)
        }
    }
}*/
